import { Server } from './server';
import { ServerConfig } from './serverConfig';

export class NetworkService {
  protected socket: WebSocket;
  protected disconnecting: boolean;
  protected connected: boolean;
  protected listeners: any[];
  protected presence: string;
  protected reconnects: number;
  protected community: string;
  protected pingTime: number;
  protected lastCheckNetworkTime: number;

  constructor() {
    this.socket = null;
    this.disconnecting = false;
    this.connected = false;
    this.listeners = [];
    this.presence = '';
    this.reconnects = 0;
    this.onMessage = this.onMessage.bind(this);
    this.community = '';
    this.pingTime = 0;
    this.lastCheckNetworkTime = 0;
    this.checkNetwork();
  }

  public setCommunity(cid:string) {
    this.community = cid;
  }

  public addEventListener(id:string, callback:Function) {
    this.listeners.push({id, callback});
  }

  public removeEventListener(id:string, callback:Function) {
    for(let i = 0; i < this.listeners.length; i++) {
      if(this.listeners[i].id == id && this.listeners[i].callback == callback) {
        this.listeners.splice(i, 1);
        return;
      }
    }
  }

  protected sendToListeners(data:any) {
    for(let i = 0; i < this.listeners.length; i++) 
      if(this.listeners[i].id == data.id) 
        this.listeners[i].callback(data);
  }

  public async connect() {
    this.disconnecting = false;

    let cparam = (this.community != '') ? '?Community=' + this.community : '';

    return new Promise((resolve, reject) => {
      this.socket = new WebSocket('wss://' + ServerConfig.socketDev + cparam);

      this.socket.onopen = (event)=>{
        if(window.location.hostname.includes('localhost'))
          console.log('--> Network Connect');
        this.connected = true;
        this.reconnects = 0;
        this.sendToListeners({id: 'connect'});
        resolve({success: true});
      };
  
      this.socket.onerror = (event)=> {
        if(window.location.hostname.includes('localhost')) {
          console.log('<-- Network Error!');
          console.log(event);
        }
        this.socket = null;
        this.connected = false;
        resolve({success: false});
      };
  
      this.socket.onclose = (event)=>{
        if(window.location.hostname.includes('localhost'))
          console.log('<-- Network Disconnect');
        this.socket = null;
        this.connected = false;
        this.reconnects++;
        this.sendToListeners({id: 'disconnect'});
        if(!this.disconnecting) {
          if(this.reconnects < 3 && document.hasFocus())
            this.reconnect();
          else
            console.warn('Failed to reconnect to Network!')
        } 
      };
  
      this.socket.onmessage = this.onMessage;
    });
  }

  public disconnect() {
    if(this.socket) {
      this.disconnecting = true;
      this.socket.close();
      this.socket = null;
    }
  }

  public abnormalDisconnect() {
    if(this.socket)
      this.socket.close();
  }

  protected reconnect() {
    // if(window.location.hostname.includes('localhost'))
    //   console.log('Reconnecting to Network...');
    // setTimeout(async () => {
    //   if(Server.isLoggedIn() && !this.isConnected())
    //     await Server.refreshServiceLogin();
    //     this.connect();
    // }, 1000);
  }

  public isConnected(): boolean {
    if(!this.socket) 
      return false;
    return (this.socket.readyState == WebSocket.OPEN);
  }

  protected onMessage(message:any) {
    // console.log(event);
    let event = JSON.parse(message.data);
    if(window.location.hostname.includes('localhost'))
      console.log('<--', event);
    this.sendToListeners(event);
  }

  public async sendCommand(id:string, params:any = null) {
    if(!Server.isLoggedIn())
      return;
      
    if(!this.socket)
      return;

    let command = null;
    if(params) 
      command = {id, ...params};
    else 
      command = {id};

    if(window.location.hostname.includes('localhost'))
      console.log('-->', command);

    if(this.community != '')
      command.community = this.community;

    try {
      this.socket.send(JSON.stringify(command));
    }
    catch(e) {
      console.error('Failed to send command!');
      console.log(e);
      // window.location.reload();
    }
  }

  protected checkNetwork() {
    let now = performance.now();
    if(this.lastCheckNetworkTime == 0)
      this.lastCheckNetworkTime = now;
    let elapsed = (now - this.lastCheckNetworkTime) / 1000;
    this.lastCheckNetworkTime = now;

    if(this.isConnected()) {
      this.pingTime += elapsed;

      if(window.location.hostname.includes('localhost'))
        console.log('checkNetwork', this.pingTime.toFixed(0), new Date().toLocaleTimeString());

      if(this.pingTime >= 180) {
        this.pingTime = 0;
        this.sendCommand('ping');
      }
    }
    else {
      this.pingTime = 0;
    }

    setTimeout(() => {
      this.checkNetwork();
    }, 60 * 1000);
  }
}